var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"acceso-directo",class:{simplificado: _vm.simplificado_activo},attrs:{"to":_vm.to}},[_c('div',{staticClass:"imagen-acceso"},[_c('img',{staticClass:"imagen",attrs:{"src":_vm.src}})]),_c('div',{staticClass:"nombre-acceso"},[_c('p',[_c('span',[_vm._v(_vm._s(_vm.titulo))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }